import React from 'react';
import PersonProfileModal from '@/components/People/PersonProfileModal';

/**
 * Stacks a person's full profile in a SheetModal on top of an already-open
 * modal (e.g. the create-person modal). Route-pushing a card screen on top of
 * a modal presentation doesn't stack reliably (web replaces, native dismisses
 * the underlying modal), so we render the profile component inside a
 * component-level modal instead.
 *
 * @param {string|null} personId - The person to review. When non-null, the modal opens.
 * @param {Function} onClose - Called when the modal is dismissed.
 */
const DuplicateReviewModal = ({ personId, onClose }) => (
    <PersonProfileModal
        personID={personId}
        onClose={onClose}
        title="Review Profile"
        subtitle="Possible duplicate"
    />
);

export default DuplicateReviewModal;
